var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      ref: "select",
      style: { width: _vm.width },
      attrs: {
        value: _vm.selectKey,
        placeholder: _vm.placeholder,
        size: _vm.size,
        filterable: "",
        clearable: "",
        "filter-method": _vm.handleFilter,
      },
      on: { clear: _vm.handleClear, "visible-change": _vm.handleVisibleChange },
    },
    [
      _c("el-option", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        attrs: { value: _vm.selectKey, label: _vm.selectLabel },
      }),
      _c("el-tree", {
        ref: "tree",
        staticClass: "grade-tag-select-tree",
        attrs: {
          data: _vm.treeData,
          props: { children: "children", label: "desc" },
          "node-key": "nodeKey",
          "default-expand-all": "",
          "expand-on-click-node": false,
          "filter-node-method": _vm.filterNode,
          "highlight-current": "",
        },
        on: { "node-click": _vm.handleNodeClick },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ data }) {
              return _c("span", { staticClass: "grade-tag-node" }, [
                _c("span", { staticClass: "node-label" }, [
                  _vm._v(_vm._s(data.desc)),
                ]),
                data.children && data.children.length
                  ? _c("span", { staticClass: "node-count" }, [
                      _vm._v(_vm._s(data.children.length) + "项"),
                    ])
                  : _vm._e(),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }